import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import CustomBadge from "./CustomBadge.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'ImpactBadge',
  props: {
  isPositive: {
    type: Boolean,
  },
  isZero: {
    type: Boolean,
  },
  percentage: {
    type: String,
    required: true,
  },
},
  setup(__props) {

const props = __props;

const bgColor = computed(() => (props.isPositive ? "bg-green" : "bg-red"));

const displayText = computed(() => {
  return (
    (props.isZero ? "" : props.isPositive ? "+" : "-") + props.percentage + "%"
  );
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(CustomBadge, {
    bgColor: bgColor.value,
    text: displayText.value
  }, null, 8, ["bgColor", "text"]))
}
}

})